<template>
  <div>
    <el-dialog title="查看发票" :visible.sync="dialogVisible" :append-to-body="true" width="700px" :before-close="handleClose">
      <div v-loading="loading">
        <div class="base-info">
          <el-row>
            <el-col :span="10">发票类型：{{ invoiceInfo.OrderInvoiceTypee_txt }}</el-col>
            <el-col :span="14">订单状态：{{ orderState || orderStatusChange(invoiceInfo) }}</el-col>
            <el-col :span="10">发票内容：商品明细</el-col>
            <el-col :span="14">订单编号：{{ invoiceInfo.OrderNo }}</el-col>
            <el-col :span="10">发票抬头：{{ invoiceInfo.CompanyName }}</el-col>
            <el-col :span="14">下单时间：{{ invoiceInfo.CreateTime }}</el-col>
          </el-row>
        </div>
        <!-- <div v-if="invoiceInfo.OrderInvoiceItem.length > 0" class="invoice-info"> -->
        <div v-if="true" class="invoice-info">
          <p class="hint">部分药品由于税率原因，无法开具增值税专用发票，平台将默认补充电子发票。</p>
          <ul>
            <li v-for="(item, index) in invoiceInfo.OrderInvoiceItem" :key="index">
              <p>
                发票类型：
                <strong>{{ item.InvoiceType }}</strong>
              </p>
              <p>
                发票号：
                <strong>{{ item.InvoiceNo }}</strong>
              </p>
              <button v-if="item.InvoiceType === '电子发票'" @click="handleLookInvoice(item)">查看发票</button>
              <button v-else @click="handleLogistics(invoiceInfo.Id)">查看物流</button>
            </li>
            <div v-if="!!invoiceInfo.IsAutomaticInvoicing">
              <button
                v-if="!invoiceInfo.EnumAuditStatus"
                class="reInvoice"
                :disabled="false"
                @click="reInvoiceEvt"
              >
                发票有误，重开发票
              </button>

              <button
                v-if="invoiceInfo.EnumAuditStatus===1"
                class="reInvoice"
                disabled
              >
                发票有误，重开发票
                <el-tag size="mini" @click.stop="show_remind=true">审核中</el-tag>
              </button>

              <div v-if="invoiceInfo.EnumAuditStatus==2 && invoiceInfo.OrderInvoiceItem.length>0" class="invoice-tips">发票已重新开具，请点击查看</div>
              <button
                v-if="invoiceInfo.EnumAuditStatus===2 && invoiceInfo.OrderInvoiceItem.length<1"
                class="reInvoice"
                disabled
              >
                发票有误，重开发票
                <el-tag size="mini" type="info" @click.stop="show_remind=true">已确认</el-tag>
              </button>

              <button
                v-if="invoiceInfo.EnumAuditStatus===3"
                class="reInvoice"
                :disabled="false"
                @click="reInvoiceEvt"
              >
                发票有误，重开发票
                <el-tag size="mini" type="danger" @click.stop="show_remind=true">已拒绝</el-tag>
              </button>
            </div>
          </ul>
        </div>
        <!-- <div class="download-invoice" v-if="showDownload" @click='downloadInvoice'>下载发票</div> -->
      </div>
    </el-dialog>
    <a-modal v-model="tipsModel" centered :footer="null" :closable="false" width="700px">
      <div v-loading="loading" class="tips-cont">
        <div class="tips-row">
          <h4 style="text-align: left;">发票物流</h4>
          <img class="image-close" :src="require('@/assets/buycar/model-close.png')" @click="() => (tipsModel = false)">
        </div>
        <div class="tips-logistics-cont">
          <div class="tips-logistics-title">
            <p>发票类型：增值税专用发票（纸质版）</p>
            <p>配送方式：{{ tipsModelDefaultData.LogisticsCompanyName }}</p>
            <p>快递单号：{{ tipsModelDefaultData.LogisticsWaybillNo }}</p>
          </div>
          <div
            v-show="tipsModelDefaultData !== '' && tipsModelDefaultData.LogisticsDocmentTrail && tipsModelDefaultData.LogisticsDocmentTrail.length > 0"
            class="tips-logistics-alternate"
          >
            <a-timeline mode="left">
              <a-timeline-item v-for="(item, index) in tipsModelDefaultData.LogisticsDocmentTrail" :key="index" color="gray">
                <div class="alternate-item">
                  <div class="alternate-item-data">{{ item.Time }}</div>
                  <img class="alternate-item-icon" :src="index === 0 ? require('@/assets/buycar/wl-active.svg') : require('@/assets/buycar/wl.svg')">
                  {{ item.Note }}
                </div>
              </a-timeline-item>
            </a-timeline>
          </div>
          <div class="tips-logistics-empty"><a-empty :description="false" /></div>
        </div>
      </div>
    </a-modal>
    <el-image-viewer v-if="showDownload" :on-close="closeLookInnvoice" :url-list="[downloadUrl]" />
    <!-- 申请开票弹框 -->
    <el-dialog v-if="iApplyInvoice" :visible.sync="iApplyInvoice" :append-to-body="true" width="700px" :show-close="false" custom-class="el-apply-invoice">
      <!-- <van-overlay :show="iApplyInvoice" z-index="5" @click="iApplyInvoice = false"> -->
      <div class="wrapper" @click.stop><ApplyInvoiceForm ref="iApplyInvoice" isdialog @cancel="handleCancelInvoice" @confirm="handleConfirmInvoice" /></div>
    <!-- </van-overlay> -->
    </el-dialog>
    <!--
      * 重开发票提示 model
      * haolin.hu
      * 2022.2.16
      -->
    <a-modal
      v-model="show_remind"
      centered
      :footer="null"
      :closable="false"
      :mask-closable="false"
      width="573px"
      :body-style="{ padding: 0 }"
      :z-index="9999"
    >
      <div class="flex-remind-box" style="height: 200px;">
        <div class="flex-remind-header">
          温馨提示
          <img
            class="image-close"
            src="../../assets/buycar/model-close.png"
            @click="() => {
              show_remind = false
            }"
          >
        </div>
        <div v-if="invoiceInfo.EnumAuditStatus===1" class="flex-remind-body">
          <div class="subtitle" style="padding-top: 8px; text-align: center;">
            <div>发票重开申请已提交，</div>
            <div>系统会在1-3个工作日进行审核处理，请耐心等待。</div>
          </div>
        </div>
        <div v-if="invoiceInfo.EnumAuditStatus===2" class="flex-remind-body">
          <div class="subtitle" style="padding-top: 8px; text-align: center;">
            <div>发票重开申请审核通过，</div>
            <div>系统将在1-3个工作日为您重新开具，请耐心等待。</div>
          </div>
        </div>
        <div v-if="invoiceInfo.EnumAuditStatus===3" class="flex-remind-body">
          <div class="subtitle" style="padding-top: 8px; text-align: center;">
            <div>发票重开申请已拒绝，</div>
            <div>拒绝原因【{{ invoiceInfo.ReasonRejection || '-' }}】，</div>
            <div>您可以修改后重新提交。</div>
          </div>
        </div>
        <div class="flex-remind-footer">
          <van-button
            color="#0F6EEA"
            @click.stop="
              () => {
                show_remind = false
              }
            "
          >
            好的
          </van-button>
        </div>
      </div>
    </a-modal>
    <!-- 重开发票 model end -->
  </div>
</template>
<script>
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
export default {
  components: { ElImageViewer },
  props: ['orderState'],
  data() {
    return {
      loading: false,
      dialogVisible: false,
      invoiceInfo: {
        OrderInvoiceItem: []
      },
      orderId: null,
      tipsModel: false,
      tipsModelDefaultData: '',
      showDownload: false,
      downloadUrl: '',
      reInvoiceAble: true,
      iApplyInvoice: false,
      show_remind: false,
      orderInfo: {}
    }
  },
  methods: {
    handleClose() {
      this.dialogVisible = false
    },
    handleShow(i) {
      this.getInvoiceInfo(i.Id)
      this.orderId = i.Id
      this.orderInfo = JSON.parse(JSON.stringify(i))
      this.dialogVisible = true
    },
    orderStatusChange(item) {
      let statusName = ''
      if (item.OrderState == 1) {
        if (item.OrderPaymentState == 1 || item.OrderPaymentState == 2 || item.OrderPaymentState == 7) {
          statusName = '待付款'
        } else if (item.OrderLogisticsState == 6) {
          statusName = '待发货'
        } else if (item.OrderLogisticsState == 3) {
          statusName = '已发货'
        } else if (item.OrderLogisticsState == 5) {
          statusName = '已收货'
        }
      } else if (item.OrderState == 2 && item.OrderLogisticsState == 5) {
        statusName = '已收货'
      } else if (item.OrderState == 3) {
        statusName = '已关闭'
      }
      return statusName
    },
    // 发票预览
    handleLookInvoice(i) {
      if (i.InvoiceImgSrc) {
        this.showDownload = true
        this.dialogVisible = false
        this.downloadUrl = i.InvoiceImgSrc
        this.addDownloadButton()
        return
      }
      if (i.InvoiceURL) {
        window.open(i.InvoiceURL, '_blank')
      }
      // window.open(i.InvoiceImgSrc||i.InvoiceURL, '_blank');
    },
    closeLookInnvoice() {
      this.showDownload = false
      this.dialogVisible = true
      this.removeDownloadButton()
    },
    // 追加下载发票按钮
    addDownloadButton() {
      const link = document.createElement('a')
      link.id = 'download-invoice'
      link.href = this.downloadUrl
      link.setAttribute('download', '发票')
      // link.target='_blank'
      const text = document.createTextNode('下载发票')
      link.appendChild(text)
      document.body.appendChild(link)
    },
    removeDownloadButton() {
      const link = document.getElementById('download-invoice')
      document.body.removeChild(link)
    },
    // 查看物流
    async handleLogistics(id) {
      this.dialogVisible = false
      this.tipsModel = true
      this.loading = true
      const successData = await this.postAction('api_logistics/LogisticsDocment/GetLogisticsDocmentByOrderIds?businessDocmentType=4', [this.orderId])
      this.tipsModelDefaultData = successData.Data[0]
      this.loading = false
    },
    async getInvoiceInfo(orderId) {
      this.loading = true
      const res = await this.getAction('/api_aftersale/OrderInvoice/GetOrderInvoice', { orderId })
      this.loading = false
      if (res.IsSuccess && res.Data) {
        this.invoiceInfo = res.Data[0] || {}

        // 纸质发票
        // if (res.Data[0].OrderInvoiceMediumType === 2 && res.Data[0].OrderInvoiceType === 2) {
        // 	// 根据id获取物流信息
        // 	let ids = [];
        // 	ids.push(res.Data[0].Id);
        // 	const successData = await this.postAction('api_logistics/LogisticsDocment/GetLogisticsDocmentByOrderIds?businessDocmentType=4', ids);
        // 	if (successData.IsSuccess && successData.Data.length > 0) {
        // 		this.tipsModelDefaultData = successData.Data[0];
        // 		// 开启model
        // 		this.tipsModel = true;
        // 	} else {
        // 		this.$toast.fail('暂无物流信息');
        // 	}
        // } else {
        // 	// 非纸质发票，跳转发票详情页面
        // 	this.Info = res.Data.length ? res.Data[0] : null;
        // 	// window.open(this.Info.OrderEInvoiceAddress, '_blank');
        // }
      } else {
        this.$toast.fail(res.Msg)
      }
    },
    // 申请开票
    goApplyInvoice(id) {
      this.iApplyInvoice = true
      this.$router.push({ query: { reInvoice: true }})
      setTimeout(() => {
        this.$refs.iApplyInvoice.setApplyInvoiceId(id)
      }, 1000)
    },
    // 取消开票
    handleCancelInvoice() {
      this.iApplyInvoice = false
    },
    // 确认开票
    handleConfirmInvoice() {
      this.iApplyInvoice = false
      this.pageindex = 1
      this.getOrderData()
    },
    async reInvoiceEvt() {
      // if (!this.invoiceInfo.EnumAuditStatus) return false
      this.dialogVisible = false
      this.goApplyInvoice(this.orderInfo)
    }
  }
}
</script>
<style lang="less" scope>
.base-info {
  margin-bottom: 40px;
  border-radius: 1px;
  padding: 20px 15px;
  font-size: 14px;
  text-align: left;
  color: #222222;
  background: #FFFFFF;
  box-shadow: 0 2px 8px 0 rgba(223, 223, 223, .5);
  line-height: 28px;
}

.invoice-info {
  text-align: left;
  color: #777777;

  .hint {
    line-height: 16px;
    font-size: 12px;
  }

  li {
    position: relative;
    border-bottom: 1px solid #EFEFEF;
    padding: 20px 0;
    font-size: 14px;
    list-style: none;

    &:last-child {
      border-bottom: none;
    }

    p {
      margin-bottom: 6px;
    }

    strong {
      font-weight: normal;
      color: #222222;
    }

    button {
      position: absolute;
      top: 20px;
      right: 0;
      border: none;
      text-decoration: underline;
      color: #0F6EEA;
      background: #FFFFFF;
      outline: none;
      cursor: pointer;
    }
  }
}

#download-invoice {
  position: fixed;
  bottom: 37px;
  left: 50%;
  z-index: 99999;
  margin-left: 150px;
  border-radius: 5px;
  width: 100px;
  height: 30px;
  text-align: center;
  color: #D8D8D8;
  background: #67686C;
  opacity: .8;
  line-height: 30px;
  cursor: pointer;

  &:hover {
    opacity: 1;
  }
}

.reInvoice {
  position: absolute;
  right: 20px;
  bottom: 20px;
  border: none;
  font-size: 14px;
  text-decoration: underline;
  color: #0F6EEA;
  background: #FFFFFF;
  outline: none;
  cursor: pointer;

  &[disabled="disabled"] {
    color: #C5CAD5;
    cursor: not-allowed;
  }

  .el-tag {
    margin-left: 10px;
    color: #0F6EEA;
    cursor: pointer;

    &.el-tag--danger {
      color: #FF3939;
    }

    &.el-tag--info {
      color: #111A34;
    }
  }
}

.invoice-tips {
  font-size: 14px;
  text-align: right;
  text-decoration: underline;
  color: #0F6EEA;
}
</style>
<style lang="less">
.el-apply-invoice {
  margin: 5% auto !important;
  width: 1200px !important;

  >.el-dialog__header {
    padding: 0;
  }

  >.el-dialog__body {
    padding: 0;
  }
}
</style>
